"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, HostBinding, Input } from '@angular/core';
var TooltipContentComponent = (function () {
    function TooltipContentComponent() {
        this.position = 'bottom-center';
    }
    __decorate([
        Input(),
        HostBinding('attr.data-position'),
        __metadata("design:type", String)
    ], TooltipContentComponent.prototype, "position", void 0);
    TooltipContentComponent = __decorate([
        Component({
            selector: 'fl-tooltip-content',
            template: "\n    <ng-content></ng-content>\n  ",
            styleUrls: ['./tooltip-content.component.scss'],
        })
    ], TooltipContentComponent);
    return TooltipContentComponent;
}());
export { TooltipContentComponent };



// WEBPACK FOOTER //
// tooltip-content.component.js